import type React from "react"

import { ConfirmationModal } from "../components/confirmationModal"

/**
 * ConfirmationModalProvider component that wraps the application with the ConfirmationModal component.
 * This provider ensures that the ConfirmationModal component is always rendered at the top of the application.
 */
export function ConfirmationModalProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <ConfirmationModal />
    </>
  )
}
